module.exports = __webpack_public_path__ + "static/z16-2-0001-tablet-41e35304cf5403dd597a31f48c74a029.jpg";